module.exports = __webpack_public_path__ + "img/yjjy1.6d9a5e2c.png";